import { WithSubMenus } from "../components/SubMenus"
import {
    Activated,
    ActivationExpired,
    ChangePassword,
    FAQ,
    ForgotPassword,
    Login,
    Register,
    RegistrationSuccess,
    RequestQuote,
    ResetPassword
} from "../pages"
import { OrderPlanning } from "../pages"
import { PlaceOrder, UserOrderDetail, UserOrders } from "../pages/order"
import { OrderConfirmationPage } from "../pages/order/OrderConfirmationPage"
import Profile from "../pages/user/Profile"
import { ProtectedRoute } from "./ProtectedRoute"
import { useContext, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { UserContext } from "../context"
import { isAdmin } from "../utils/userUtils"

function MySpaceDefault() {
    const navigate = useNavigate()
    const { user } = useContext(UserContext)

    // wait for the real session user before deciding (guest placeholder has no id)
    const loaded = !!user?.id
    // ungrouped non-admin users land on "Place an Order" instead of the group planning calendar
    const canPlan = isAdmin(user) || !!user?.groupid

    useEffect(() => {
        if (!loaded) return
        navigate(canPlan ? "/myspace/orderplanning" : "/myspace/placeorder", { replace: true })
    }, [loaded, canPlan, navigate])

    if (!loaded) return null
    return canPlan ? <OrderPlanning /> : <PlaceOrder />
}

export const userRoutes = [
    { path: "login", element: <Login /> },
    { path: "register", element: <Register /> },
    { path: "registration-success", element: <RegistrationSuccess /> },
    { path: "activated", element: <Activated /> },
    { path: "activation-expired", element: <ActivationExpired /> },
    { path: "resetpassword", element: <ResetPassword /> },
    { path: "forgotpassword", element: <ForgotPassword /> },
    { path: "changepassword", element: <ChangePassword /> },
    {
        path: "order",
        element: (
            <ProtectedRoute>
                <WithSubMenus>
                    <PlaceOrder />
                </WithSubMenus>
            </ProtectedRoute>
        ),
    },
    {
        path: "myspace/placeorder",
        element: (
            <ProtectedRoute>
                <WithSubMenus>
                    <PlaceOrder />
                </WithSubMenus>
            </ProtectedRoute>
        ),
    },
    {
        path: "myspace/myorders",
        element: (
            <ProtectedRoute>
                <WithSubMenus>
                    <UserOrders />
                </WithSubMenus>
            </ProtectedRoute>
        ),
    },
    {
        path: "myspace/requestquote",
        element: (
            <ProtectedRoute>
                <WithSubMenus>
                    <RequestQuote />
                </WithSubMenus>
            </ProtectedRoute>
        ),
    },
    {
        path: "myspace/order/:orderId",
        element: (
            <ProtectedRoute>
                <WithSubMenus>
                    <UserOrderDetail />
                </WithSubMenus>
            </ProtectedRoute>
        ),
    },

    {
        path: "myspace/faq",
        element: (
            <ProtectedRoute>
                <WithSubMenus>
                    <FAQ />
                </WithSubMenus>
            </ProtectedRoute>
        ),
    },
    {
        path: "myspace/orderplanning",
        element: (
            <ProtectedRoute>
                <WithSubMenus>
                    <OrderPlanning />
                </WithSubMenus>
            </ProtectedRoute>
        ),
    },

    // {
    //     path: "/terms",
    //     element: (
    //         <ProtectedRoute>
    //             <WithSubMenus>
    //                 <Terms />
    //             </WithSubMenus>
    //         </ProtectedRoute>
    //     ),
    // },
    {
        path: "/myspace/profile",
        element: (
            <ProtectedRoute>
                <WithSubMenus>
                    <Profile />
                </WithSubMenus>
            </ProtectedRoute>
        ),
    },
    {
        path: "/order/confirmation",
        element: (
            <ProtectedRoute>
                <WithSubMenus>
                    <OrderConfirmationPage />
                </WithSubMenus>
            </ProtectedRoute>
        ),
    },
    {
        path: "myspace/*",
        element: (
            <ProtectedRoute>
                <WithSubMenus> 
                    <MySpaceDefault />
                </WithSubMenus>
            </ProtectedRoute>
        ),
    },
]
